import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { Form, Input } from "antd";
import AddSavingsAccCharge from "./AddSavingsAccCharge";
import CloseSavingsAcc from "./CloseSavingsAcc";
import Deposit from "./Deposit";
import RejectSavingsAcc from "./RejectSavingsAcc";
import Withdraw from "./Withdraw";

const { TextArea } = Input;
const WalletAccountMainActionPage = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(state);
  }, []);

  const renderActions = () => {
    switch (state?.actionLabel?.toLowerCase()) {
      case "cash in":
        return <Deposit userData={userData} />;
      case "cash out":
        return <Withdraw userData={userData} />;
      case "reject":
        return <RejectSavingsAcc userData={userData} />;
      case "add sub wallet":
        return <AddSavingsAccCharge userData={userData} />;
      case "apply charge":
        return <AddSavingsAccCharge userData={userData} />;

      case "close":
        return <CloseSavingsAcc userData={userData} />;
      default:
        return <>No {state.actionLabel} Component found contact dev</>;
    }
  };
  return <>{renderActions()}</>;
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(WalletAccountMainActionPage);
